import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as actions from './actions'

export const useUserAccess = () => {
    const {
        refresh,
        initialize,
        users = [],
    } = useSelector((state) => state.userAccess);

    const dispatch = useDispatch();

    const setUsers = useCallback(
        (payload) => dispatch(actions.setUsers(payload)),
        [dispatch]
    );

    return {
        refresh,
        initialize,
        users,
        setUsers,
    };
} 